import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, destroyLenis } from "@/lib/lenis";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-obsidian text-warm">
          <p className="text-mutegray">Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </ErrorBoundary>
      <Toaster theme="dark" position="top-right" />
      <div className="grain-overlay" aria-hidden="true" />
    </BrowserRouter>
  );
}

export default App;
